import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { get as _get, has as _has } from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { fromVehicleActions } from '@amfam/policy/vehicle/data-access';
import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access';
import { fromRouterActions } from '@amfam/shared/utility/navigation';
import { DockingBarService, PageTitleService } from '@amfam/ui-kit';

import * as fromRoot from '../../core/store';
import * as replaceVehicleActions from '../../core/store/replace-vehicle/replace-vehicle.actions';
import { ReplaceVehicleService } from '../../core/store/replace-vehicle/replace-vehicle.service';

@Component({
  selector: 'ds-replace-vehicle',
  templateUrl: './replace-vehicle.component.html',
  styleUrls: ['./replace-vehicle.component.scss'],
  standalone: false
})
export class ReplaceVehicleComponent implements OnInit, OnDestroy {
  yearMakeVisible = false;
  yearVinVisible = true;
  policyNumber: string;
  replaceVin: string;

  private vehicleId: string;

  // Shared subject for completing observables
  private stop$: Subject<void> = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private store: Store<fromRoot.RootState>,
    private pageTitle: PageTitleService,
    private dockingBarService: DockingBarService,
    private feature: FeatureFlagService,
    private replaceVehicleService: ReplaceVehicleService
  ) {}

  ngOnInit() {
    this.pageTitle.set('Replace a Vehicle');
    this.dockingBarService.registerHeading('Replace a Vehicle');

    // Dispatch an action to re-initialize the replaceVehicle state
    this.store.dispatch(new replaceVehicleActions.ReplaceVehicleInitAction());

    // Dispatch an action to clear the vehicle select state
    this.store.dispatch(fromVehicleActions.Reset());

    // Get the policy number
    this.route.params.pipe(takeUntil(this.stop$)).subscribe(params => {
      this.vehicleId = params['id'];
    });

    // Subscribe to get the advance auto risks
    this.store
      .select(fromRoot.getReplaceVehicleRisks)
      .pipe(takeUntil(this.stop$))
      .subscribe(vehicles => {
        if (vehicles) {
          const matchingVehicle = vehicles.find(vehicle => {
            return _get(vehicle, 'id') === this.vehicleId;
          });
          if (this.replaceVehicleService.getAdvancePolicyEligibility(matchingVehicle)) {
            this.policyNumber = matchingVehicle.policyNumber;
            this.replaceVin = matchingVehicle.vin;
          } else {
            this.store.dispatch(
              fromRouterActions.Go({
                path: ['/policies/replace-vehicle/' + this.vehicleId + '/grace-period'],
                extras: { replaceUrl: true }
              })
            );
          }
        }
      });

    this.store
      .select(fromRoot.getReplaceVehiclePremium)
      .pipe(takeUntil(this.stop$))
      .subscribe(premium => {
        if (_has(premium, 'monthlyPremium')) {
          this.store.dispatch(
            fromRouterActions.Go({
              path: ['/policies/replace-vehicle/' + this.vehicleId + '/review'],
              extras: { replaceUrl: true }
            })
          );
        }
      });
  }

  ngOnDestroy() {
    this.stop$.next();
    this.stop$.complete();
  }

  toggleVehicleSelection(value) {
    switch (value) {
      case 'yearVin':
        this.yearMakeVisible = false;
        this.yearVinVisible = true;
        break;
      default:
        this.yearMakeVisible = true;
        this.yearVinVisible = false;
        break;
    }
  }
}
